import { jsx as _jsx } from "react/jsx-runtime";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { FormattedMessage } from "react-intl";
import resetPasswordSlice from "slices/ResetPassword";
export function GoBackButton({ onClickHandler, primary }) {
    const loginRef = useAppSelector((state) => state.login.ref);
    const dispatch = useAppDispatch();
    const dashboard_link = useAppSelector((state) => state.config.dashboard_link);
    if (!onClickHandler && !loginRef) {
        // for the default click handler, loginRef is mandatory
        return null;
    }
    function onClick(e) {
        e.preventDefault();
        if (onClickHandler) {
            onClickHandler();
        }
        else if (dashboard_link) {
            document.location.href = dashboard_link;
            dispatch(resetPasswordSlice.actions.resetEmailStatus());
        }
    }
    const style = primary ? "primary" : "secondary";
    return (_jsx(EduIDButton, { buttonstyle: `${style} normal-case`, id: "go-back-button", onClick: onClick, children: _jsx(FormattedMessage, { id: "goBackButton.button", defaultMessage: "Go back", description: "Account recovery Go back button" }) }));
}
